import createCache from '@emotion/cache'
import { prefixer } from 'stylis'
import rtlPlugin from 'stylis-plugin-rtl'

/**
 * Emotion caches for each direction. The RTL cache runs stylis-plugin-rtl,
 * which mirrors any physical CSS that slipped through.
 *
 * This is a safety net, not a licence: components must still use logical
 * properties (marginInlineStart, insetInlineEnd) so the source reads correctly
 * in both directions.
 */
export const ltrCache = createCache({ key: 'mui', stylisPlugins: [prefixer] })

export const rtlCache = createCache({
  key: 'mui-rtl',
  stylisPlugins: [prefixer, rtlPlugin as never],
})

export function cacheFor(direction: 'ltr' | 'rtl') {
  return direction === 'rtl' ? rtlCache : ltrCache
}
